import { ICategoryDetails } from '@/models/categories.model';

export const normalizeSeoData = (categoryDetails: ICategoryDetails) => {
  const transformed: {
    [locale: string]: {
      seo_description: string;
      seo_title: string;
      seo_keywords: string[];
      seo_text: string;
    };
  } = {};

  categoryDetails.locale.forEach(({ locale, seo_description, seo_title, keywords, seo_text }) => {
    transformed[locale] = {
      seo_description: seo_description ?? '',
      seo_title: seo_title ?? '',
      seo_keywords: Array.isArray(keywords) ? keywords : [],
      seo_text: seo_text ?? '',
    };
  });

  return { locale: transformed };
};
